import {isName, isPhoneNumber} from '@dofleini/validator';
import i18n from 'i18next';
import isEmpty from 'lodash/isEmpty';

const addressVerification = /^(?=.*[/+#^()_=[{}'"@$!%*?&-])([/+#^()_=[{}'"@$!%*?&-]|[^ ])/;
const urlVerification = /^http[s]?:\/\/[\w]+([.]+[\w]+)+[/\w_()?=&#-]+$/;

export const baseFields = [
  {
    key: 'name',
    label: 'name',
    required: true,
    placeholder: 'name',
    rules: [isName],
  },
];

export const validations = {
  mustBeCheck: (message, skipFileValidation) => ({
    validator(_, value) {
      if (value?.active && (skipFileValidation || value?.file)) {
        return Promise.resolve();
      }
      return Promise.reject(i18n.t(message || 'forms:validations:mustBeCheck'));
    },
  }),
  descriptionLength: (max = 500) => ({
    validator(_, value) {
      if (!value || value.length <= max) {
        return Promise.resolve();
      }
      return Promise.reject(i18n.t('forms:validations:descriptionLength_less_than', {max}));
    },
  }),
  textLength: (max = 128, min = 2) => ({
    validator(_, value) {
      if (!value || (value.length <= max && value.length >= min)) {
        return Promise.resolve();
      }
      return Promise.reject(i18n.t('forms:validations:textLength_between', {max, min}));
    },
  }),
  addressLength: (max = 255, min = 2) => ({
    validator(_, value) {
      if (!value || (value.length <= max && value.length >= min)) {
        return Promise.resolve();
      }
      return Promise.reject(i18n.t('forms:validations:addressLength_between', {max, min}));
    },
  }),
  addressValidator: () => ({
    validator: (rule, value) => {
      if (!addressVerification.test(value) && isNaN(value)) {
        return Promise.resolve();
      }
      return Promise.reject(new Error(i18n.t('forms:validations:addressValidation')));
    }
  }),
  min2Pictures: (max = 2) => ({
    validator(_, value) {
      if (isEmpty(value) || value.length === max) {
        return Promise.resolve();
      }
      return Promise.reject(i18n.t('forms:validations:dniPictures', {max}));
    },
  }),
  listPhones: () => ({
    validator: (rule, value) => {
      if (value && value.some((e) => e?.phone && !isPhoneNumber(e?.phone, true))) {
        return Promise.reject(new Error(i18n.t('someInvalidPhoneNumber')));
      } else {
        return Promise.resolve();
      }
    },
  }),
  phoneValidator: (max = 15) => ({
    validator(_, value) {
      if (isEmpty(value) || value.some((e) => e?.phone.length <= max + 1)) {
        return Promise.resolve();
      }
      return Promise.reject(i18n.t('forms:validations:phoneValidation', {max}));
    },
  }),
  url: () => ({
    validator: (rule, value) => {
      if (!urlVerification.test(value)) {
        return Promise.reject(new Error(i18n.t('forms:validations:invalidWebsite')));
      }
      return Promise.resolve();
    }
  }),
  nitLength: (max = 11, min = 11) => ({
    validator(_, value) {
      if (!value || (value.length === max && value.length === min)) {
        return Promise.resolve();
      }
      return Promise.reject(i18n.t('forms:validations:nitLength', {max}));
    },
  }),
  nitNumber: () => ({
    validator: (rule, value) => {
      if (isNaN(value)) {
        return Promise.reject(new Error(i18n.t('invalidNIT')));
      }
      return Promise.resolve();
    }
  }),
  text: () => ({
    validator: (rule, value) => {
      if (isNaN(value) && isName(value)) {
        return Promise.resolve();
      }
      return Promise.reject(new Error(i18n.t('forms:validations:invalidText')));
    }
  }),
  valueNotZero: () => ({
    validator: (rule, value) => {
      if (value > 0) {
        return Promise.resolve();
      }
      return Promise.reject(new Error(i18n.t('forms:validations:invalidValue')));
    }
  }),
  bannedWordsCheck: (settings) => ({
    validator: (rule, value) => {
      return new Promise((resolve, reject) => {
        const wordBanned = settings?.socialDenominationBannedWords?.split(',')?.find(word => {
          const rgx = new RegExp(word?.trim(), 'gi');
          return rgx.test(value);
        });
        if (value && !!wordBanned) {
          reject(new Error(i18n.t('proposalRequest:proposalRequest.form.general.name.bannedWords', {
            word: wordBanned
          })));
        } else {
          resolve();
        }
      });
    }
  })
};
